const minin = {
  data() {
    return {
      baseUrl: 'contract',
      getListUrl: 'orderec',
      formCtrl: [
        {
          label: '装货日期：',
          keyName: 'starttime',
          placeholder: '选择日期',
          type: 'daterange',
        },
        { ...this.ctrls.license },
      ],
      curSearchKey: 'shname',
      curSearchValue: undefined,
      searchDateOptions: [
        { label: '装货日期', keyName: 'starttime', },
        { label: '卸货日期', keyName: 'edittime', },
      ],
      searchKeyOptions: [
        { label: '客户名称', value: 'shname', },
        { label: '车牌号', value: 'license', },
      ],
      cols: [
        { prop: 'order_num', label: '订单编号', width: 150 },
        { prop: 'fleet_nickname', label: '车队长' },
        { prop: 'license', label: '车牌号', minwidth: 120 },
        { prop: 'driver', label: '司机' },
        { prop: 'coaddress', label: '装货地址' },
        { prop: 'enaddress', label: '卸货地址' },
        { prop: 'starttime', label: '装货日期', minwidth: 120 },
        //{ prop: 'trailer', label: '挂车号', minwidth: 120 },
        { prop: 'inton', label: '装车重量', align: 'right', className: 'pr30', minwidth: 120 },
        { prop: 'unton', label: '卸车重量', align: 'right', className: 'pr30', minwidth: 120 },
      ],
      btns: [
        {
          ...this.editBtn,
          cb: ({ id }) => {
            this.$router.push(
              `/contract/orderdetail?id=${id}&mode=edit`
            );
          },
        },
      ],
      baseParams: ['contractid', 'ischeck', 'isstatus'],
      btnloading: false,
    };
  },
  methods: {
    getExport() {
      this.btnloading = true
      let url = `order/expicture`;
      const params = {
        // userid: this.user.id,
        order_list: []
      }
      if (this.tableData && this.tableData.length) {
        this.tableData.map(v => {
          params.order_list.push(v.id)
        })
      }
      console.log(url, params)
      this.post(url, params, (res) => {
        this.btnloading = false
        // console.log(res)
        const { msg, url } = res
        if (msg === 'success' && url) {
          console.log(url)
          var link = document.createElement('a')
          link.href = url
          link.download = "过磅单"
          link.click()
        } else {
          this.$message({
            message: msg || '导出失败，请稍后再试！',
            type: 'error',
          });
        }
      }, err => {
        console.log(err)
        this.$message({
          type: 'error',
          message: '获取数据失败，请稍后重试！'
        });
      })
    },
  },
  mounted() {
    const { id } = this.$route.query
    this.formInline.contractid = id
    this.getList()
    const { user_group_id } = this.user
    if ([5].includes(user_group_id)) {
      this.btns[0] = {
        ...this.viewBtn,
        cb: ({ id }) => {
          this.$router.push(
            `/contract/orderview?id=${id}&mode=view`
          );
        },
      }
    }
  },
}

export default minin